import BaseFilter from "@shared/components/filters/BaseFilter.jsx";
import { PACKAGE_STATUS_OPTIONS, PACKAGE_FILTER_CONFIG } from "../constants";

export default function FilterPackages({ onFilter, currentFilters = {} }) {
  return (
    <BaseFilter
      onFilter={onFilter}
      currentFilters={currentFilters}
      statusOptions={PACKAGE_STATUS_OPTIONS}
      config={PACKAGE_FILTER_CONFIG}
    />
  );
}
